import React from 'react';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';


const styles = (theme) => ({
  container: {
    maxWidth: theme.layout.containerMaxWidth,
    margin: '0 auto',
  },
});


function Container(props) {
  const {classes, className, ...otherProps} = props;

  return (
    <div className={classNames(classes.container, className)} {...otherProps}>
      {props.children}
    </div>
  )
}

export default withStyles(styles)(Container);


// WEBPACK FOOTER //
// ./src/parts/Container.js